import React, { useState, useEffect, useRef, useContext } from "react";
import "./clientes.css";
import { clientesData } from "../../json/clientes";
import { LanguageContext } from "../../context/LanguageContext/LanguageContext";

const Clientes = () => {
  const { language } = useContext(LanguageContext); // Idioma actual
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(5); // Por defecto (desktop)
  const [containerWidth, setContainerWidth] = useState(0);
  const refContainer = useRef(null);

  const { title, subtitle, clientes } = clientesData[language]; // Datos dinámicos según idioma

  useEffect(() => {
    const updateLayout = () => {
      if (refContainer.current) {
        const width = refContainer.current.offsetWidth;
        setContainerWidth(width);

        if (width <= 767) {
          setVisibleSlides(1); // Móvil
        } else if (width <= 1023) {
          setVisibleSlides(3); // Tablet
        } else {
          setVisibleSlides(4); // Desktop
        }
      }
    };

    window.addEventListener("resize", updateLayout);
    updateLayout();

    return () => {
      window.removeEventListener("resize", updateLayout);
    };
  }, []);

  useEffect(() => {
    const maxIndex = Math.max(0, clientes.length - visibleSlides);

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % (maxIndex + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, [visibleSlides, clientes]);

  const getTransform = () => {
    const spacing = 20;
    const slideWidth = containerWidth / visibleSlides;
    return `translateX(-${currentIndex * (slideWidth + spacing)}px)`;
  };

  const getTrackWidth = () => {
    const spacing = 20;
    const slideWidth = containerWidth / visibleSlides;
    return clientes.length * slideWidth + (clientes.length - 1) * spacing;
  };

  return (
    <div className="container nuestros-container">
      <div className="nuestros-titulo">
        <span className="subtitulo">{subtitle}</span>
        {title}
      </div>
      <div className="carousel" ref={refContainer}>
        <div className="carousel-track-container">
          <ul
            className="carousel-track"
            style={{
              transform: getTransform(),
              width: `${getTrackWidth()}px`
            }}
          >
            {clientes.map((cliente, index) => {
              const slideWidth = containerWidth / visibleSlides;

              return (
                <li
                  key={index}
                  className="carousel-slide"
                  style={{
                    width: `${slideWidth}px`,
                    marginRight: "20px"
                  }}
                >
                  <div
                    className="carousel-image"
                    style={{
                      backgroundImage: `url(${cliente.logo})`,
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      width: "100%",
                      height: "200px"
                    }}
                  ></div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Clientes;
